import { Message } from 'paho-mqtt';
import camelcaseKeys from 'camelcase-keys';

export function parseMqttMessage(message: Message) {
  // !! CASTING JUST TO FIX NEW ERRORS AFTER UPDATING TYPESCRIPT TO TREAT PARSE VALUES AS UNKNOWN. SHOULD ADD SCHEMA VALIDATION.
  const payload = JSON.parse(message.payloadString) as Record<string, unknown>;
  const camelCasedPayload = camelcaseKeys(payload, { deep: true });

  return camelCasedPayload;
}
